import React, { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { TypeAnimation } from "react-type-animation";
import TopReview from "./TopReview";

const TopReviews = () => {
  const [topReviews, setTopReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://food-for-you-server.vercel.app/topreviews`)
      .then((res) => res.json())
      .then((data) => {
        setTopReviews(data);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <section>
        <div className="row d-flex justify-content-center">
          <div className="col-md-10 col-xl-8 text-center">
            <h2
              className="mt-4 mt-lg-5 mb-4 text-dark fw-semibol"
              data-aos="fade-right"
              data-aos-duration="2500"
            >
              <TypeAnimation
                sequence={["What My Customer Says", 3000]}
                speed={40}
                cursor={false}
                repeat={Infinity}
              />
            </h2>
            <p
              className="mb-4 pb-2 mb-md-5 pb-md-0 cust-say text-secondary mx-auto fs-my-8"
              data-aos="fade-left"
              data-aos-duration="2500"
            >
              <TypeAnimation
                sequence={[
                  "Customers are looking for on-demand food delivery services with the convenience they provide. My Food delivery web app is a good match with their supply and demand. Customers expect timely and quick food delivery and quality customer service. They are satisfied with my website service.",
                  3000,
                ]}
                speed={40}
                cursor={false}
                repeat={Infinity}
              />
            </p>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <ScaleLoader color="#007b96" height="18" speedMultiplier=".6" />
            <span className="fw-semibold fs-my-10 text-danger">
              Wait! Data is loading..
            </span>
          </div>
        ) : (
          <div className="row text-center mt-5 mb-top-review w-top-review mx-auto">
            {topReviews.map((topReview) => (
              <TopReview
                key={topReview._id}
                topReview={topReview}
                loading={loading}
                setLoading={setLoading}
              ></TopReview>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default TopReviews;
